"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  mapService: 'WMS',
  imageFormat: 'PNG',
  mapLayerPosition: 'BASEMAP'
};
exports.default = _default;
//# sourceMappingURL=externalMapLayer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/d2/model/config/model-defaults/externalMapLayer.js
// module id = 1235
// module chunks = 0